module.exports = __webpack_public_path__ + "static/media/profesional-inactive.15faf007.svg";